var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { classNames } from "../Util";
import { useDimensions } from "../Hook";
var LockableTd = function (_a) {
    var colIndex = _a.colIndex, col = _a.col, contents = _a.contents, nColumns = _a.nColumns, dragHandleProps = _a.dragHandleProps, _b = _a.isDragging, isDragging = _b === void 0 ? false : _b;
    var ref = useRef(null);
    var _c = useDimensions(ref), width = _c.width, height = _c.height;
    return (_jsx("td", __assign({ ref: ref }, dragHandleProps, { className: classNames("whitespace-nowrap text-sm", col.secondary !== undefined && col.secondary
            ? "text-gray-500"
            : "font-medium text-gray-900", col.alignRight !== undefined && col.alignRight
            ? "py-4 pl-4 pr-3 text-right pl-3"
            : "px-3 py-4", (colIndex === (nColumns - 1)) ? " pr-4 sm:pr-6" : "", colIndex === 0
            ? " sm:pl-6"
            : "", col.showOnBreakpoint ? col.showOnBreakpoint : "", col.tdClassName ? col.tdClassName : ""), style: {
            width: isDragging ? "".concat(width, "px") : undefined,
            height: isDragging ? "".concat(height, "px") : undefined,
        } }, { children: contents })));
};
export default LockableTd;
